module.exports = __webpack_public_path__ + "assets/slider-revolution.9367adaa.svg";